export default {
  setServiceList ({ commit }, payload) {
    commit('setServiceList', payload)
  }
}
